/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Current_Trip_Force_EndInputs */

const vi_vehicle_current_trip_force_end = /** @type {(inputs: Vehicle_Current_Trip_Force_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kết thúc chuyến (tài xế quên)`)
};

/**

* @param {Vehicle_Current_Trip_Force_EndInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vehicle_current_trip_force_end = /** @type {((inputs?: Vehicle_Current_Trip_Force_EndInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Current_Trip_Force_EndInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vehicle_current_trip_force_end(inputs)
});